import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {DELETE_COMMISSION_REPORT_DETAIL} from '../../../gql/mutations/commissionReportDetailMutations'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import { IResDeleteCommissionReportDetail } from '../../../types/commissionReportDetailApi'

interface IModalDeleteCommissionReportDetail {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string;}
}

export const ModalDeleteCommissionReportDetail: React.FC<IModalDeleteCommissionReportDetail> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const intl = useIntl()
  const [gqlDeleteCommissionReportDetail, {data, loading, error}] = useMutation<IResDeleteCommissionReportDetail>(DELETE_COMMISSION_REPORT_DETAIL)

  useEffect(() => {
    if (error) toast.error(intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message: error.message}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.commissionReportDetailDeleteMutation?.success) {
      toast.success(intl.formatMessage({id: 'commissions.detail.delete.toast.success', defaultMessage: 'Success: The record has been deleted successfully'}))
      onClose()
      refetch()
    } else if (data.commissionReportDetailDeleteMutation?.errors?.length > 0) {
      toast.error(intl.formatMessage(
        {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
        {message: data.commissionReportDetailDeleteMutation?.errors?.[0]?.message || intl.formatMessage({id: 'commissions.logs.somethingHappened', defaultMessage: 'something happened'})}
      ))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDeleteCommissionReportDetail({
      variables: {
        id: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='commissions.logs.delete.title' defaultMessage='Delete report record' /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='text-primary'>
          <FormattedMessage id='commissions.logs.delete.confirm' defaultMessage='Are you sure you want to delete this record?' />
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button
          variant='danger'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          <FormattedMessage id='common.action.delete' defaultMessage='Delete' />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
